export default class Menu {
    constructor(barraPrincipal) {
        this.principal = barraPrincipal;
        this.opcionesPrincipales = Array.from(barraPrincipal.querySelectorAll("& > li > :is([role^='menuitem'], button)"));
        this.esVertical = (barraPrincipal.getAttribute("aria-orientation") === "vertical");
        this.configurar();
    }

    configurar() {
        this.navegarConTeclado = this.navegacionTeclasCallback();
        this.intentarDesbordar = this.opcionClickCallback();
        const opciones = this.principal.querySelectorAll(":is([role^='menuitem'], button)");

        for (const opcion of opciones) {
            opcion.tabIndex = -1;
            opcion.addEventListener("click", this.intentarDesbordar);
        }

        opciones[0].tabIndex = 0;
        this.principal.addEventListener("keydown", this.navegarConTeclado);
    }

    cambiarTabindex(anteriorOpcion, nuevaOpcion, cambiarFocus) {
        anteriorOpcion.tabIndex = -1;
        nuevaOpcion.tabIndex = 0;
        if (cambiarFocus) {
            anteriorOpcion.blur();
            nuevaOpcion.focus();
        }
    }

    desbordarSinMenuAdjunto(opcion, cambiarFocus) {
        if (this.opcionesPrincipales.includes(opcion)) {
            return;
        }

        const menusDesbordados = Array.from(this.principal.querySelectorAll("[aria-expanded='true']")),
                cantidadOpcionesPrincipales = this.opcionesPrincipales.length;
        for (const menu of menusDesbordados) {
            menu.setAttribute("aria-expanded", "false");
        }
        const indiceOpcionActiva = this.opcionesPrincipales.indexOf(menusDesbordados[0]),
                nuevoIndiceActivo = (indiceOpcionActiva + 1) % cantidadOpcionesPrincipales,
                nuevaOpcionActiva = this.opcionesPrincipales[nuevoIndiceActivo];
        this.cambiarTabindex(opcion, nuevaOpcionActiva, cambiarFocus);
    }

    desbordarConMenuAdjunto(opcion, menuAdjunto, cambiarFocus) {
        const nuevaOpcionActiva = menuAdjunto.querySelector("& > li > :is([role^='menuitem'], button)");
        opcion.setAttribute("aria-expanded", "true");
        this.cambiarTabindex(opcion, nuevaOpcionActiva, cambiarFocus);
    }

    colapsarOpcionPrincipal(opcion, menuAdjunto, cambiarFocus) {
        const nuevaOpcionActiva = Array.from(
                menuAdjunto.querySelectorAll("& > li > :is([role^='menuitem'], button)")
                ).at(-1);
        this.cambiarTabindex(opcion, nuevaOpcionActiva, cambiarFocus);
    }

    colapsarOpcionSubmenu(opcion, cambiarFocus) {
        const nuevaOpcionActiva = opcion.closest("[role='menu']").previousElementSibling;
        nuevaOpcionActiva.setAttribute("aria-expanded", "false");
        this.cambiarTabindex(opcion, nuevaOpcionActiva, cambiarFocus);
    }

    navegacionTeclasCallback() {
        return (event) => {
            const {key, target: opcion} = event,
            esPrincipalHorizontal = this.opcionesPrincipales.includes(opcion) && !this.esVertical,
                    siguiente = (esPrincipalHorizontal ? "ArrowRight" : "ArrowDown"),
                    anterior = (esPrincipalHorizontal ? "ArrowLeft" : "ArrowUp"),
                    desbordar = (esPrincipalHorizontal ? "ArrowDown" : "ArrowRight"),
                    colapsar = (esPrincipalHorizontal ? "ArrowUp" : "ArrowLeft"),
                    conjuntoOpciones = Array.from(
                            opcion.closest(":is([role='menu'], [role='menubar'])")
                            .querySelectorAll("& > li > :is([role^='menuitem'], button)")
                            ),
                    cantidadOpciones = conjuntoOpciones.length,
                    menuAdjunto = opcion.nextElementSibling;
            let nuevaOpcionActiva,
                    indiceOpcionActiva,
                    nuevoIndiceActivo,
                    menusDesbordados;

            switch (key) {
                case siguiente:
                    event.preventDefault();
                    indiceOpcionActiva = conjuntoOpciones.indexOf(opcion);
                    nuevoIndiceActivo = (indiceOpcionActiva + 1) % cantidadOpciones;
                    nuevaOpcionActiva = conjuntoOpciones[nuevoIndiceActivo];
                    this.cambiarTabindex(opcion, nuevaOpcionActiva, true);
                    break
                case anterior:
                    event.preventDefault();
                    indiceOpcionActiva = conjuntoOpciones.indexOf(opcion);
                    nuevoIndiceActivo = (indiceOpcionActiva - 1 + cantidadOpciones) % cantidadOpciones;
                    nuevaOpcionActiva = conjuntoOpciones[nuevoIndiceActivo];
                    nuevaOpcionActiva = conjuntoOpciones[nuevoIndiceActivo];
                    this.cambiarTabindex(opcion, nuevaOpcionActiva, true);
                    break
                case desbordar:
                    if (opcion.nodeName === "BUTTON") {
                        return;
                    }

                case "Enter":
                    if (!menuAdjunto) {
                        if (key === "Enter") {
                            return;
                        }

                        event.preventDefault();
                        this.desbordarSinMenuAdjunto(opcion, true);
                        break
                    }

                    event.preventDefault();
                    this.desbordarConMenuAdjunto(opcion, menuAdjunto, true);
                    break
                case colapsar:
                    if (opcion.nodeName === "BUTTON") {
                        return;
                    }

                    event.preventDefault();
                    if (this.opcionesPrincipales.includes(opcion)) {
                        if (!menuAdjunto) {
                            return;
                        }

                        this.colapsarOpcionPrincipal(opcion, menuAdjunto, true);
                        break
                    }

                    this.colapsarOpcionSubmenu(opcion, true);
                    break
                case "Home":
                    event.preventDefault();
                    if (cantidadOpciones === 1) {
                        return;
                    }

                    nuevaOpcionActiva = conjuntoOpciones[0];
                    this.cambiarTabindex(opcion, nuevaOpcionActiva, true);
                    break
                case "End":
                    event.preventDefault();
                    if (cantidadOpciones === 1) {
                        return;
                    }

                    nuevaOpcionActiva = conjuntoOpciones[cantidadOpciones - 1];
                    this.cambiarTabindex(opcion, nuevaOpcionActiva, true);
                    break
                case "Escape":
                    event.preventDefault();
                    nuevaOpcionActiva = opcion.closest("[role='menu']").previousElementSibling;

                    if (!nuevaOpcionActiva) {
                        return;
                    }

                    nuevaOpcionActiva.setAttribute("aria-expanded", "false");
                    this.cambiarTabindex(opcion, nuevaOpcionActiva, true);
                default:
                    return;
            }

            return true;
        };
    }

    opcionClickCallback() {
        return (event) => {
            const {currentTarget: opcion} = event,
            {nodeName} = opcion,
            opcionActiva = opcion.getAttribute("aria-current") === "page",
                    opcionConMenu = opcion.hasAttribute("aria-haspopup"),
                    opcionDesbordada = opcion.getAttribute("aria-expanded") === "true",
                    menuAdjunto = opcion.nextElementSibling;
            let menusDesbordados,
                    opcionConFocus;

            if (nodeName === "A" && (/*opcionActiva ||*/ opcionConMenu)) {
                event.preventDefault();

                return;
            }

            if (nodeName === "BUTTON") {
                menusDesbordados = Array.from(this.principal.querySelectorAll("[aria-expanded='true']"))
                        .filter(menu => !menu.nextElementSibling.contains(opcion));
                for (const menuDesbordado of menusDesbordados) {
                    menuDesbordado.setAttribute("aria-expanded", "false");
                }
                if (opcionDesbordada) {
                    opcionConFocus = menuAdjunto.querySelector("[tabindex='0']");
                    this.cambiarTabindex(opcionConFocus, opcion, false);
                } else {
                    this.desbordarConMenuAdjunto(opcion, menuAdjunto, false);
                }
            }
        };
    }
}